var cov_1wj2ith0py = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/styles/index.ts",
      hash = "a9da7e0b6a84e9b00e0cec8c5b6316799adbc0cc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var checkinputLess = {};
import genaration from '../../utils/classname';
export var checkinputClass = (cov_1wj2ith0py.s[0]++, genaration(checkinputLess, 'checkinput'));